import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const ImageCarousel = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '20%'
      }}
    >
      <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false}>
        {[
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/pichuninuni.appspot.com/o/Maac%2F20250211_111911.jpg?alt=media&token=a9e692dd-ed0f-455d-bafc-bde990ba48e7',
            alt: 'Traducción Simultánea',
            caption: 'Traducción Simultánea',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/pichuninuni.appspot.com/o/Maac%2F20231122_094241.jpg?alt=media&token=7483cc19-efcc-41ae-9944-2fd956f1741e',
            alt: 'Sonido Profesional',
            caption: 'Sonido Profesional',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/pichuninuni.appspot.com/o/Maac%2FMaac%2013.jpg?alt=media&token=c9b2169b-2306-4ce2-9af4-a5e508a744f3',
            alt: 'Proyección HD',
            caption: 'Proyección HD',
          },
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/pichuninuni.appspot.com/o/Maac%2F20221121_145548.jpg?alt=media&token=adb9bc40-bf75-484d-b1fb-da141c198a47',
            alt: 'Pantallas LED',
            caption: 'Pantallas LED',
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              aspectRatio: '21 / 9',
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <img
              src={item.src}
              alt={item.alt}
              style={{
                width: '100%',
                height: '80%',
                objectFit: 'cover',
              }}
            />
            <p className="legend">{item.caption}</p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default ImageCarousel;

